export const student12MenuGroups = {
	planningRoom: {
		title: 'Planning Room',
		icon: 'calendar',
		items: [
			{ key: 'Agenda', label: 'Agenda', path: 'student-tasks', icon: 'check-square' },
			{ key: 'Schedule', label: 'Schedule', path: 'student-schedule', icon: 'calendar' },
			{ key: 'Timeline', label: 'Timeline', path: 'student-timeline', icon: 'clock' }
		]
	},
	college: {
		title: 'College',
		icon: 'graduation',
		items: [
			{ key: 'CollegeList', label: 'College List', path: 'student-college-list', icon: 'list' },
			{ key: 'Deadlines', label: 'Deadlines', path: 'student-deadlines', icon: 'alert-circle' },
			{ key: 'FinancialAid', label: 'Fin. Aid', path: 'student-financial-aid', icon: 'dollar-sign' }
		]
	},
	writings: {
		title: 'Writings',
		icon: 'edit',
		items: [
			{ key: 'Activities/Awards', label: 'Activities/Awards', path: 'student-12-activities', icon: 'award' },
			{ key: 'MainEssay', label: 'Main Essay', path: 'student-main-essay', icon: 'file-text' },
			{ key: 'SuplementalEssay', label: 'Supplementals', path: 'student-supplemental-essay', icon: 'file' },
			{ key: 'AddInfo', label: 'Additional Info', path: 'student-additional-info', icon: 'info' },
			{ key: 'BragSheet', label: 'BragSheet', path: 'student-brag-sheet', icon: 'star' }
		]
	}
}

export const student911MenuGroups = {
	planningRoom: {
		title: 'Planning Room',
		icon: 'calendar',
		items: [
			{ key: 'Agenda', label: 'Agenda', path: 'student-tasks', icon: 'check-square' },
			{ key: 'Schedule', label: 'Schedule', path: 'student-schedule', icon: 'calendar' },
			{ key: 'PersonalQuestions', label: 'Career', path: 'student-personal-questions', icon: 'briefcase' },
			{ key: 'CollegeList911', label: 'College List', path: 'student-911-college-list', icon: 'list' }
		]
	},
	academics: {
		title: 'Academics',
		icon: 'book',
		items: [
			{ key: 'GradeList', label: 'GPA-Grades', path: 'student-grade-list', icon: 'trending-up' },
			{ key: 'GradeList2', label: 'GPA-Grades 2', path: 'student-grade-list-2', icon: 'trending-up' },
			{ key: 'Lessons', label: 'Rigor-Courses', path: 'student-lessons', icon: 'book-open' },
			{ key: 'GoalGrades', label: 'SAT', path: 'student-goal-questions', icon: 'target' },
			{ key: 'BookList', label: 'Readings', path: 'student-booklist', icon: 'book' }
		]
	},
	activities: {
		title: 'Activities',
		icon: 'activity',
		items: [
			{ key: 'Activity', label: 'Activities', path: 'student-911-activities', icon: 'zap' },
			{ key: 'Awards', label: 'Awards', path: 'student-911-awards', icon: 'award' },
			{ key: 'congressional-awards', label: 'Congressional Awards', path: 'student-911-congressional-awards', icon: 'award' }
		]
	}
}
